import { Handshake } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const AUDIENCE = ["Sex workers", "Adult performers", "Content creators", "Everyday people"];

const joinAsCreator = () => {
  window.dispatchEvent(new CustomEvent("sr:waitlist-role", { detail: "creator" }));
  document.getElementById("waitlist")?.scrollIntoView({ behavior: "smooth" });
};

export const Creators = () => (
  <section id="creators" className="relative py-24 lg:py-36 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 items-center">
      <Reveal className="lg:col-span-5 order-2 lg:order-1">
        <div className="relative aspect-[4/5] rounded-[40px] overflow-hidden group">
          <img src="/img/portrait.jpg" alt="Creator portrait" className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-700" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#FF2A8D]/25 via-transparent to-[#070A14]" />
          <div className="absolute bottom-6 left-6 right-6 glass rounded-2xl p-4 flex items-center gap-3">
            <Handshake className="text-[#5B95D6] shrink-0" size={22} />
            <p className="text-sm text-slate-200">Creator partnerships · opening soon</p>
          </div>
        </div>
      </Reveal>
      <div className="lg:col-span-7 order-1 lg:order-2 lg:pl-8">
        <Reveal><Eyebrow color="text-[#5B95D6]">Creator partnerships</Eyebrow></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1]">
            Your audience trusts you.<br /><span className="text-duo">Help them get tested.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p data-testid="creators-copy" className="mt-6 text-slate-300 text-base sm:text-lg leading-relaxed max-w-xl">
            Creators and performers who want to spread real sex education with Sweet Results can join the waitlist now. We'll reach out about potential partnerships.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="mt-6 flex flex-wrap gap-2">
            {AUDIENCE.map((a) => <span key={a} className="rounded-full border border-white/15 px-4 py-1.5 text-sm text-slate-300">{a}</span>)}
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <button data-testid="creators-join-waitlist-btn" onClick={joinAsCreator}
            className="mt-10 inline-flex items-center justify-center gap-2 rounded-full bg-[#125AA0] hover:bg-[#1A6BBE] px-7 py-4 font-semibold transition-colors">
            <Handshake size={18} /> Join the waitlist as a creator
          </button>
        </Reveal>
      </div>
    </div>
  </section>
);
